import { render } from "./AdminAccount.vue?vue&type=template&id=cc168a5e&ts=true"
import script from "./AdminAccount.vue?vue&type=script&lang=ts"
export * from "./AdminAccount.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__